// React Dependencies
import React, { useEffect, useState } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { Icon, MenuList, MenuItem } from '@material-ui/core';

// Internal Dependencies
import PageDetailsRouter from './detailsRouter';
import Constants from '../../common/constants';
import Images from '../basics/Images';
import { editPage, getPage } from '../../actions/admin/pageAction';
import { IsEmpty } from '../../common/checks';

const PageDetails = ({ match, pageInView, editPage, getPage }) => {
  const [goToPageListScreen, setGoToPageListScreen] = useState(false);

  useEffect(() => {
    // fetch the page data
    async function fetchPageData() {
      const page = await getPage(match.params.id);
      if (page) {
        editPage(page);
      }
    }
    fetchPageData();
  }, [editPage, getPage, match.params.id]);

  return goToPageListScreen ? <Redirect to="/admin/page" /> : (
    <>
      <div className="row" style={{}}>
        <div className="col-md-12">
          <div className="d-flex justify-content-start content-header">
            <h1 className="d-flex align-items-center">
              <Link to="/admin/page" title="Back" className="d-flex align-items-center">
                <Icon className="back">arrow_back</Icon>
              </Link>
              {pageInView ? pageInView.name : ''}
            </h1>

            {pageInView ? pageInView.isOfficial && (
              <div className="ml-2">
                <img src={Images.Local.Authorised} width="24px" alt="isOfficial" />
              </div>
            ) : null}
            <div />

          </div>
          <div className="row">
            <div className="col-md-2" style={{ backgroundColor: '#fff' }}>
              <MenuList>
                <Link to={`${match.url}`}><span><MenuItem>Info</MenuItem></span></Link>

                {
                  (pageInView && [Constants.PageType.Mall, Constants.PageType.HawkerCentre].includes(pageInView.type))
                  && <Link to={`${match.url}/openinghours`}><span><MenuItem>Opening Hours</MenuItem></span></Link>
                }

                <Link to={`${match.url}/photos`}><span><MenuItem>Photos</MenuItem></span></Link>

                {
                  !IsEmpty(pageInView) && pageInView.type === Constants.PageType.Photographer && (
                    <Link to={`${match.url}/snapstyr`}><span><MenuItem>Snapstyr</MenuItem></span></Link>
                  )
                }

                {
                  !IsEmpty(pageInView) && pageInView.type === Constants.PageType.Photographer && (
                    <Link to={`${match.url}/albums`}><span><MenuItem>Albums</MenuItem></span></Link>
                  )
                }

                {/** Display 'Outlet's only for specific page type */}
                {
                  (
                    pageInView
                    && [Constants.PageType.FNB, Constants.PageType.Retailer, Constants.PageType.EventsCompany].includes(pageInView.type)
                  ) && (
                    <Link to={`${match.url}/outlets`}>
                      <span><MenuItem>Outlets</MenuItem></span>
                    </Link>
                  )
                }

                <Link to={`${match.url}/posts`}><span><MenuItem>Posts</MenuItem></span></Link>

                {
                  (pageInView && pageInView.type === Constants.PageType.AreaManagement) && (
                    <>
                      <Link to={`${match.url}/genericHighlight`}>
                        <span><MenuItem>Generic Highlight</MenuItem></span>
                      </Link>
                      <Link to={`${match.url}/foodReviewHighlight`}>
                        <span><MenuItem>Food Review Highlight</MenuItem></span>
                      </Link>
                      <Link to={`${match.url}/highlights?isSpecial=true`}>
                        <span><MenuItem>Special Highlights</MenuItem></span>
                      </Link>
                      <Link to={`${match.url}/highlights?isExclusive=true`}>
                        <span><MenuItem>Exclusive Highlights</MenuItem></span>
                      </Link>
                    </>
                  )
                }

                {pageInView && [Constants.PageType.AreaManagement, Constants.PageType.Mall, Constants.PageType.View].includes(pageInView.type) && <Link to={`${match.url}/pinnedPosts`}><span><MenuItem>Pinned Posts</MenuItem></span></Link>}

                {
                  pageInView
                  && pageInView.type === Constants.PageType.FoodReview
                  && (
                    <>
                      <Link to={`${match.url}/reviews`}><span><MenuItem>Reviews</MenuItem></span></Link>
                      <Link to={`${match.url}/trails`}><span><MenuItem>Trails</MenuItem></span></Link>
                    </>
                  )
                }
                {pageInView && [Constants.PageType.Mall, Constants.PageType.AreaManagement].includes(pageInView.type) && <Link to={`${match.url}/geographicBoundary`}><span><MenuItem>Geographic Boundary</MenuItem></span></Link>}

                {pageInView && pageInView.type === Constants.PageType.AreaManagement && <Link to={`${match.url}/partnerBuildings`}><span><MenuItem>Partner Buildings</MenuItem></span></Link>}
                {pageInView && pageInView.giftEnabled && <Link to={`${match.url}/vouchers-coupons`}><span><MenuItem>Vouchers & Coupons</MenuItem></span></Link>}
                {pageInView && pageInView.giftEnabled && <Link to={`${match.url}/loyaltyCards`}><span><MenuItem>Loyalty Cards</MenuItem></span></Link>}
                {pageInView && pageInView.prefixCode === 'SKC' && <Link to={`${match.url}/promo-codes`}><span><MenuItem>Promo codes</MenuItem></span></Link>}
                {pageInView && pageInView.giftEnabled && <Link to={`${match.url}/luckyDraws`}><span><MenuItem>Lucky Draws</MenuItem></span></Link>}
                {pageInView && pageInView.type === Constants.PageType.AreaManagement && <Link to={`${match.url}/featureControl`}><span><MenuItem>Feature Control</MenuItem></span></Link>}
                <Link to={`${match.url}/status`}><span><MenuItem>Status</MenuItem></span></Link>
              </MenuList>
            </div>
            <div className="col-md-10 card-left">
              <PageDetailsRouter match={match} />
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

PageDetails.propTypes = {
  match:      PropTypes.shape(Object).isRequired,
  pageInView: PropTypes.shape(Object).isRequired,
  editPage:   PropTypes.func.isRequired,
  getPage:    PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  pageInView: state.admin.page.pageInView,
});

export default connect(mapStateToProps, { editPage, getPage })(PageDetails);
